<script>
export default {
  name: 'CardImagesEmpty',
  props: {
    imageUrl: {
      type: String,
      required: true,
    },
  },
}
</script>

<template>
  <div class="rounded overflow-hidden">
    <div class="h-40">
      <img class="w-full h-full" alt="img" :src="imageUrl" />
    </div>
  </div>
</template>
